module.exports = "/_next/static/images/hero-bg-light-062e8e56088a07b4b8fa78572c6d065b.png.webp";